/* istanbul ignore file */
import RestClient from '../RestClient/RestClient';
import { apiHosts } from '../RestClient/FetchHelper.config';
import { cstToUTC } from '../Common/CommonHelper';
import { getCookie } from '../helpers/Cookies';

const DP_PREVIEW_DATE = 'DP_PREVIEW_DATE';

export const getPromoBanner = ({ canonicalUrl = '', channel, pTmplType, ppid, headers = {} }) => {
    let previewDate = '';
    const context = RestClient.getContext();
    const url = `/${
        context.isPreview ? 'prvcontent-aggregator' : 'content-aggregator'
    }/shared-components/zones/s1${canonicalUrl || '/pdp'}`;
    const apiHost = apiHosts.content;
    const isXCloudHeaderRequired = true;
    const params = {
        pTmplType,
        ppid,
    };
    if (context.isPreview) {
        const dateValue = cstToUTC(getCookie(DP_PREVIEW_DATE), context);
        previewDate = (dateValue || new Date()).toISOString();
    }

    const config = {
        apiHost,
        excludeVersion: true,
        channel,
        ...(!canonicalUrl && { params }),
        previewDate,
        isXCloudHeaderRequired,
        url,
        timeout: 2000,
        cacheControl: headers['cache-control'],
    };
    return RestClient.get(config)
        .then((json) => json.data)
        .catch((error) => {
            console.log(`request failed ${error}`);
        });
};
